import React, { Component } from "react";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import { isLoggedIn } from "../../store/iam/selectors";
import Login from "../auth/Login";
import Register from "../auth/Register";
import { joinRequest } from "../../store/member_requests/operations";
import LoadingIndicator from "../../components/LoadingIndicator";
import ReactGA from "react-ga";

class JoinRequestDecorator extends Component {
  state = {
    show_login: false,
    show_register: false,
    make_join_request: false,
    show_loader: false
  };
  hideLogin = () => {
    this.setState({ show_login: false });
  };
  showLogin = () => {
    ReactGA.event({
      category: "User",
      action: "Has seen login form"
    });
    this.setState({ show_login: true });
  };
  showRegister = () => {
    ReactGA.event({
      category: "User",
      action: "Has seen register form"
    });
    this.setState({ show_register: true });
  };

  hideRegister = () => {
    this.setState({ show_register: false });
  };

  joinRequest = () => {
    if (this.props.isLoggedIn) {
      this.setState({ show_loader: true });
      this.props.joinRequest(this.props.circleId).then(
        () => {
          this.setState({ show_loader: false });
        },
        () => {
          this.setState({ show_loader: false });
        }
      );
    } else {
      ReactGA.event({
        category: "User",
        action: "Has seen register form"
      });
      this.setState({ show_register: true, make_join_request: true });
    }
  };

  onClose = () => {
    this.setState({ show_login: false, show_register: false, make_join_request: false });
  };

  render() {
    if (this.props.isLoggedIn && this.state.make_join_request) {
      this.setState({ make_join_request: false });
      this.props.joinRequest(this.props.circleId);
    }

    let children = React.Children.map(this.props.children, (child, index) => {
      return React.cloneElement(child, { onClick: this.joinRequest });
    });

    return (
      <>
        {children}
        {this.state.show_loader && <LoadingIndicator />}

        <Login
          isOpen={this.state.show_login}
          onClose={this.onClose}
          onRegisterClick={_ => {
            this.hideLogin();
            this.showRegister();
          }}
          onAuthCallback={this.onClose}
        />
        <Register
          isOpen={this.state.show_register}
          onClose={this.onClose}
          onLoginClick={_ => {
            this.hideRegister();
            this.showLogin();
          }}
          onAuthCallback={this.onClose}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state)
});
const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to)),
  joinRequest: circleId => {
    return dispatch(joinRequest(circleId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JoinRequestDecorator);
